module.exports = __webpack_public_path__ + "ad07702003fd16103eb8b490327f14c6.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/support-business/Sapo.svg
// module id = ./assets/images/support-business/Sapo.svg
// module chunks = 0